exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-2083a5f3] {\n  font-size: 18px;\n@media (max-width: 600px) {\n> div {\n      height: 100%;\n}\n}\n}\n", ""]);

// exports
